// extracted by mini-css-extract-plugin
module.exports = {"user":"User_user__2JArK"};